import APIClient from '../state-charts/api-client';
import { t9n } from './translate';
import { TS } from '../config/translation-keys';
import IBAN from './validators/iban';
import validate_video_link from './validators/video';
import FinnishSSN from './validators/finnish-ssn';
import validate_swedish_ssn from './validators/swedish-ssn';

const validate_email = async (email) => {
  let result = await APIClient.verify_email({ email: email });
  if (!!result) {
    return { valid: false, error: result }
  } else {
    return { valid: true, error: null }
  }
};

const validate_email_settings = async (email, user_email) => {
  if (email !== user_email) {
    return await validate_email(email);
  } else {
    return { valid: true, error: null }
  }
};

const validate_phone = async (phone_obj) => {
  let result = await APIClient.verify_phone(phone_obj);
  if(!!result){
    return { valid: false, error: result }
  } else{
    return { valid: true, error: null }
  }
};

const validate_invite_email = (email, email_confirm, email_session) => {
  if (!!email_confirm) {
    if (email !== email_confirm) {
      return { valid: false, error: t9n(TS.INVITE_NOT_THE_SAME_AS_INVITE_EMAIL)}
    } else {
      return { valid: true}
     // return await validate_email(email);
    }
  // } else {
  //   if (email !== email_session) {
  //     return await validate_email(email);
  //   } else {
  //     return { valid: false, error: t9n(TS.NEW_ORDER_DESC_INV_WORKER) }
  //   }
  }
}

const validate_password = (pw, pw_confirm) => {
  if(pw === null || pw === ''){
    return { valid: false, error: t9n(TS.PW_IS_TOO_SHORT) }
  }
  if(pw.length < 6){
    return { valid: false, error: t9n(TS.PW_IS_TOO_SHORT) }
  }
  if(pw.length > 20){
    return { valid: false, error: t9n(TS.PW_IS_TOO_LONG, 20) }
  }
  if(!!pw_confirm && pw !== pw_confirm){
    return { valid: false, error: t9n(TS.NOT_THE_SAME_AS_PASSWORD) }
  }
  return { valid: true, error: null }
};

const verify_password = async (password) => {
  let result = await APIClient.verify_password({ password: password });
  if (!!result) {
    return { valid: result.verified, error: result.verified ? null : t9n(TS.SETTINGS_PW_CHANGE_ERROR)}
  }
};

const validate_first_name = (name) => {
  let first_name = t9n(TS.REGISTER_LABEL_FIRST_NAME);
  if(name === null || name === ''){
    return { valid: false, error: t9n(TS.IS_TOO_SHORT, first_name, 2) }
  }
  if(name.length < 2){
    return { valid: false, error: t9n(TS.IS_TOO_SHORT, first_name, 2) }
  }
  return { valid: true, error: null }
}

const validate_last_name = (name) => {
  let last_name = t9n(TS.REGISTER_LABEL_LAST_NAME);
  if(name === null || name === ''){
    return { valid: false, error: t9n(TS.IS_TOO_SHORT, last_name, 2) }
  }
  if(name.length < 2){
    return { valid: false, error:  t9n(TS.IS_TOO_SHORT, last_name, 2) }
  }
  return { valid: true, error: null }
}

const validate_tax_amount = (value) => {
  let result;
  try {
    let val = Number(value);
    val.toFixed(2);
    result = val >= 0.0 && val <= 100.0;
    if(result){
      return { valid: true, error: null }
    } else{
      return { valid: false, error:  t9n(TS.SETTINGS_INVALID_TAX) }
    }
  } catch (e) {
    return { valid: false, error:  t9n(TS.SETTINGS_INVALID_TAX) }
  }
};

const validate_linked_in_link = (value) => {
  let result;
  if (!value) return { valid: true, error: null }
  let linked_in_regex = "^https://((www|\\w\\w)\\.)?linkedin.com/((in/[^/]+/?)|(pub/[^/]+/((\\w|\\d)+/?){3}))$";
  result = !!value.match(linked_in_regex);
  if(result){
    return { valid: true, error: null }
  } else{
    return { valid: false, error:  t9n(TS.SETTINGS_INVALID_LINKEDIN) }
  }
};

const validate_iban = (iban, country_code) => {
  // hack for sweden
  if (country_code === 'SW') {
    return { valid: true, error: null }
  }
  let len = !!iban ? iban.length : 0;
  if (len === 0) {
    return { valid: true, error: null }
  } else {
    let result = IBAN.isValid(iban.replace(/\s/g, ''));
    if(result){
      return { valid: true, error: null }
    } else{
      return { valid: false, error:  t9n(TS.SETTINGS_INVALID_BANK) }
    }
  }
};

const validate_organization_type = (org_type, last_role, is_orderer) => {
  if (last_role === 'orderer' && is_orderer && org_type === null) {
    return { valid: false, error:  t9n(TS.SETTINGS_ORG_TYPE_INVALID_TXT) }
  }
  return { valid: true, error: null }
};

const validate_company_name = (company_name, last_role, org_type, worker_type) => {
  if (last_role === 'orderer' && org_type !== 'organization_type_company') {
      return { valid: true, error: null }
  }

  if(last_role === 'worker' && (worker_type === 'worker_type_employment' || worker_type === 'worker_type_self_employed')){
    return { valid: true, error: null }
  }

  if(!!company_name){
    return { valid: true, error: null }
  } else{
    return { valid: false, error:  t9n(TS.SETTINGS_LABEL_INVALID_COMP_NAME) }
  }
};

const validate_reg_num = (reg_num, last_role, worker_type, org_type) => {
  if (last_role === 'worker') {
    if (
      worker_type === 'worker_type_self_employed' ||
      worker_type === 'worker_type_employment'
    ) {
      return { valid: true, error: null }
    } else {
      if(!!reg_num){
        return { valid: true, error: null }
      } else{
        return { valid: false, error:  t9n(TS.SETTINGS_LABEL_INVALID_REG_NUM) }
      }
    }
  } else {
    if (org_type === 'organization_type_company') {
      if(!!reg_num){
        return { valid: true, error: null }
      } else{
        return { valid: false, error:  t9n(TS.SETTINGS_LABEL_INVALID_REG_NUM) }
      }
    } else {
      return { valid: true, error: null }
    }
  }
};

const validate_video = (video, first_validator) => {
  if (!first_validator) {
    if (video.length === 0) {
      return { valid: true, error: null }
    } else {
      let result = validate_video_link(video);
      if(result){
        return { valid: true, error: null }
      } else{
        return { valid: false, error:  t9n(TS.SETTINGS_INVALID_VIDEO) }
      }
    }
  }
};

const validate_ssn = (ssn, first_validator, country_code, last_role) => {
  let isValid = true;
  if (!!ssn) {
    if (ssn !== 0 && !first_validator) {
      let validator = null;
      switch (country_code.toUpperCase()) {
        case 'FI':
          validator = [FinnishSSN];
          break;
        case 'GB':
          validator = [
            {
              validate: function(val) {
                isValid = /^(?!BG|UK|NK|KN|TN|NT|ZZ)[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z](?:\s*\d{2}){3}\s*[A-D]$/.test(
                  val,
                );
              },
            },
          ];
          break;
        case 'SE':
          validator = [
            {
              validate: function(val) {
                isValid = validate_swedish_ssn(val);
              },
            },
          ];
          break;
        default:
          isValid = true;
      }

      if(!isValid){
        for (let i = 0; i < validator.length; i++) {
          isValid = validator[i].validate(ssn.toUpperCase());
          if (isValid) {
            break;
          }
        }
      }

    }
  } else {
    isValid = true;
  }

  if(last_role === "orderer"){
    return { valid: true, error: null }
  }
  if(isValid){
    return { valid: true, error: null }
  } else{
    return { valid: false, error: t9n(TS.SETTINGS_INVALID_SSN) }
  }
};

const Validators = {
  validate_email,
  validate_password,
  validate_first_name,
  validate_last_name,
  validate_phone,
  validate_invite_email,
  verify_password,
  validate_tax_amount,
  validate_linked_in_link,
  validate_iban,
  validate_email_settings,
  validate_organization_type,
  validate_company_name,
  validate_reg_num,
  validate_video,
  validate_ssn
}

export default Validators;